<template>
  <div class="unauthorized">
    <h2>Contact your administrator to get authorized</h2>
    <p>Your account does not currently have access to AgentPanels.</p>
    <div class="actions">
      <button @click="openSettings">Settings</button>
      <button @click="signOut">Sign Out</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from "@/composables/useAuth";

const { logout } = useAuth();

function signOut() { 
  logout(); 
}

function openSettings() {
  // Navigate to settings route when it's implemented
  // For now, maintain existing behavior
  window.location.hash = "#/settings";
}
</script>

<style scoped>
.unauthorized { 
  padding: 24px; 
  text-align: center; 
}

.actions { 
  margin-top: 16px; 
  display: flex; 
  gap: 8px; 
  justify-content: center; 
}

button { 
  padding: 8px 12px; 
}
</style>